module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rejectreason-edit"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Manage')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/reject_reasons"
    }
  }, [_vm._v(_vm._s(_vm.$t('Reject Reason List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Reject Reason Edit')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Reject Reason Edit')))]), (_vm.loading) ? _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0)]) : _c('div', [(_vm.rejectReason != null) ? _c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('rejectreason_list.label.reject_reason')))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rejectReason.data.attributes['reject-reason']),
      expression: "rejectReason.data.attributes['reject-reason']"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.reject_reason
    },
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": _vm._s(_vm.rejectReason.data.attributes['reject-reason'])
    },
    on: {
      "keyup": _vm.half,
      "touchend": _vm.half,
      "change": _vm.half,
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.rejectReason.data.attributes,
          $$idx = 'reject-reason';
        if (!Array.isArray($$exp)) {
          _vm.rejectReason.data.attributes['reject-reason'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.reject_reason),
      expression: "!validation.reject_reason"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('rejectreason_list.label.reject_reason_default_content')))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rejectReason.data.attributes['reject-reason-default-content']),
      expression: "rejectReason.data.attributes['reject-reason-default-content']"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.reject_reason_default_content
    },
    attrs: {
      "maxlength": "255",
      "rows": "6"
    },
    domProps: {
      "value": _vm._s(_vm.rejectReason.data.attributes['reject-reason-default-content'])
    },
    on: {
      "keyup": _vm.contentCounter,
      "touchend": _vm.contentCounter,
      "change": _vm.contentCounter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.rejectReason.data.attributes,
          $$idx = 'reject-reason-default-content';
        if (!Array.isArray($$exp)) {
          _vm.rejectReason.data.attributes['reject-reason-default-content'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.reject_reason_default_content),
      expression: "!validation.reject_reason_default_content"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.contentCount) + "/255")])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('rejectreason_list.label.reject_reason_priority')))]), _c('div', {
    staticClass: "col-sm-4",
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rejectReason.data.attributes['reject-reason-priority']),
      expression: "rejectReason.data.attributes['reject-reason-priority']"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.reject_reason_priority
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm._s(_vm.rejectReason.data.attributes['reject-reason-priority'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.rejectReason.data.attributes,
          $$idx = 'reject-reason-priority';
        if (!Array.isArray($$exp)) {
          _vm.rejectReason.data.attributes['reject-reason-priority'] = _vm._n($event.target.value)
        } else {
          $$exp.splice($$idx, 1, _vm._n($event.target.value))
        }
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.reject_reason_priority),
      expression: "!validation.reject_reason_priority"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validation.not_input
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.onClickSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6dce28c3!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/rejectreason-edit.pug
// module id = 844
// module chunks = 1